import {Component, Input, OnInit} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';


@Component({
    selector: 'app-question-redirect-to-url',
    templateUrl: './question-redirect-to-url.component.html',
    styleUrls: ['./question-redirect-to-url.component.scss'],
    standalone: false
})
export class QuestionRedirectToUrlComponent implements OnInit {

  @Input() question: Question;

  constructor(
    public router: Router,
    private storageService: StorageService,
  ) {

  }

  ngOnInit(): void {
    let partner_code = '';
    try{
      partner_code = this.storageService.get('partner_code', 'flow');
    } catch{}
    
    let url = this.question.answer;
    if (partner_code !=='' && partner_code) url = url + '&partner_code='+partner_code;
    this.router.navigateByUrl(url);
  }

}
